import { useLazyQuery } from "@apollo/client/react";
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { TextInput } from '../../../components/textInput/TextInput';
import { ImprimirMinutaDetalleItems } from './ImprimirMinutaDetalleItems';
import './imprimirMinutaGrilla.scss';

import fileDownload from 'js-file-download';
import moment from 'moment';
import toast from 'react-hot-toast';
import { GET_IMPRIMIR_MINUTA_DOCUMENTO } from '../../../data/graphQL/queries/ImprimirMinuta/getImprimirMinutaDocumento';
import { ListarMinutaDetalleDocs } from "../../ListarMinuta/components/ListarMinutaDetalleDocs";

export const ImprimirMinutaDetalleContent = ({
    dataRegistro,
    delegacion,
    setChildrenAction
}) => {
    const [itemsMinuta, setItemsMinuta] = useState([]);
    const [documentos, setDocumentos] = useState([]);

    useEffect(() => {
        setChildrenAction(() =>
            <div className='chip-periodo'>
                <strong>La minuta fue generada de forma automática</strong>
            </div>
        );
    }, [
        setChildrenAction]
    );

    const [getPrintDocumento, { data: docData, loading: printDocumentoLoading }] = useLazyQuery(GET_IMPRIMIR_MINUTA_DOCUMENTO, {
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (!docData) return;
        if (docData.imprimirMinutaDocumento.success) {
            const arr = new Uint8Array(docData.imprimirMinutaDocumento.valorEsperado);
            const documento = new Blob([arr], { type: 'application/pdf' });
            const fileName = 'NumFact-' + dataRegistro.numeroFactura + '.pdf';
            fileDownload(documento, fileName);
        } else {
            toast.error("No fue posible generar el documento.");
        }
    }, [docData]);

    // imprimir solo 1 minuta desde grilla
    const handlePrint = () => {
        getPrintDocumento({ variables: { minutas: [dataRegistro.idMinuta] } });
    };

    return (
        <>
            <Grid container className='minuta-card-white' spacing={1}>
                <Grid size={{ md: 12 }}>
                    <div className='section-title'>Minuta de Facturación</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Minuta Número</div>
                    <div>{dataRegistro?.idMinuta}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Contrato</div>
                    <div>{dataRegistro?.idEvaluacion}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Fecha</div>
                    <div>{dataRegistro?.fechaAlta != null && dataRegistro?.fechaAlta != '' ? moment(dataRegistro?.fechaAlta).format("DD/MM/YYYY HH:mm") : ''}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Estado</div>
                    <div>{dataRegistro?.estado}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Delegación</div>
                    <div>{delegacion}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Paciente</div>
                    <div>{dataRegistro?.paciente}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Cliente</div>
                    <div>({dataRegistro?.cliente}) {dataRegistro?.nombreCliente}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Plan</div>
                    <div>{dataRegistro?.planCuidado}</div>
                </Grid>
            </Grid>
            <br /><br />
            <Grid container className='minuta-card-white' spacing={1}>
                <Grid size={{ xs: 6, md: 6 }}>
                    <div className='section-title'>Detalle</div>
                </Grid>
                <Grid size={{ xs: 6, md: 6 }}>
                    <div style={{ width: '100%', textAlign: 'right' }}>
                        <CustomButton
                            variant='contained'
                            className='margin-right'
                            onClick={handlePrint}
                            size='small'
                            isLoading={printDocumentoLoading}>

                            Imprimir
                        </CustomButton>
                    </div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Cantidad de Conexiones</div>
                    <div>{dataRegistro?.cantConexiones}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Precio Diario</div>
                    <div>$ {dataRegistro?.precioDiario}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Precio Total</div>
                    <div>$ {dataRegistro?.total}</div>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                    <div className='minuta-card-label'>Número Factura</div>
                    <div>{dataRegistro?.numeroFactura}</div>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <ImprimirMinutaDetalleItems
                        dataRegistro={dataRegistro}
                        itemsMinuta={itemsMinuta}
                        setItemsMinuta={setItemsMinuta} />

                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <ListarMinutaDetalleDocs
                        dataRegistro={dataRegistro}
                        documentos={documentos}
                        setDocumentos={setDocumentos} />

                </Grid>
                <Grid size={{ xs: 12, md: 12 }} sx={{ marginTop: '10px' }}>
                    <TextInput
                        value={dataRegistro?.observaciones}
                        label="Observaciones"
                        placeholder="Observaciones"
                        multiline
                        rows={3}
                        maxLength={2000}
                        disabled={true} />

                </Grid>
            </Grid>
        </>);

};